var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox } from "vue";
var _hoisted_1 = { class: "position-relative" };
var _hoisted_2 = { class: "btn-group" };
var _hoisted_3 = { class: "text-truncate d-inline-block fs-6.5" };
var _hoisted_4 = { key: 0 };
var _hoisted_5 = { key: 1 };
var _hoisted_6 = { key: 2 };
var _hoisted_7 = {
    key: 0,
    class: "popup_background"
};
var _hoisted_8 = ["id"];
var _hoisted_9 = { class: "filterUI-title" };
var _hoisted_10 = { class: "title-line d-flex justify-content-between align-items-center" };
var _hoisted_11 = { class: "filter_search" };
var _hoisted_12 = ["placeholder"];
var _hoisted_13 = {
    key: 1,
    class: "bi bi-search"
};
var _hoisted_14 = { class: "row filterUI-body filterUI-body-two_depth" };
var _hoisted_15 = { class: "col-4 border-end h-100" };
var _hoisted_16 = { class: "filterUI-body-left list-group list-group-flush filterUI-body-category" };
var _hoisted_17 = ["onClick"];
var _hoisted_18 = { class: "filterUI-body-right col h-100" };
var _hoisted_19 = { class: "row filterUI-body-list" };
var _hoisted_20 = {
    key: 0,
    class: "filterUI-body-list-item"
};
var _hoisted_21 = { class: "form-check" };
var _hoisted_22 = ["id", "value"];
var _hoisted_23 = ["for"];
var _hoisted_24 = { class: "form-check" };
var _hoisted_25 = ["id", "value"];
var _hoisted_26 = ["for"];
var _hoisted_27 = {
    key: 1,
    class: "filterUI-body-right col h-100"
};
var _hoisted_28 = { class: "row filterUI-body-list" };
var _hoisted_29 = {
    key: 0,
    class: "p-3 text-secondary-200"
};
var _hoisted_30 = { class: "form-check" };
var _hoisted_31 = ["id", "value"];
var _hoisted_32 = ["for"];
var _hoisted_33 = { class: "row filterUI-footer" };
var _hoisted_34 = { class: "select_title" };
var _hoisted_35 = { class: "result d-flex flex-wrap" };
var _hoisted_36 = ["name", "value"];
var _hoisted_37 = {
    key: 0,
    class: "text-info"
};
var _hoisted_38 = { class: "text-info mx-3" };
var _hoisted_39 = ["onClick"];
var _hoisted_40 = {
    key: 1,
    class: "text-info d-flex align-items-center"
};
var _hoisted_41 = ["onClick"];
var _hoisted_42 = { class: "btns d-flex justify-content-end px-4 py-3" };
var _hoisted_43 = { class: "d-flex align-items-end" };
var _hoisted_44 = {
    class: "btn btn-primary text-white",
    type: "submit"
};
import { ref, watch, computed, onMounted, onBeforeUnmount } from 'vue';
import ApiService from '@/ts/core/services/ApiService';
// Props 정의
export default /*@__PURE__*/ _defineComponent({
    __name: 'MobileRecruitFilter',
    props: {
        options: {
            required: true,
            type: (Array),
        },
        initValue: {
            required: false,
            type: (Array),
            default: function () { return []; },
        },
        type: {
            required: true,
            type: String,
        },
        filterVisible: {
            required: true,
            type: Boolean,
        },
        locales: {
            required: true,
            type: Object,
        },
        title: {
            required: true,
            type: String
        },
    },
    emits: ['filter-toggle-event', 'update:init-value'],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        // Emits 정의
        var emit = __emit;
        // Reactive 데이터
        var lang = ref(ApiService.getLang());
        var selectedCategory = ref(null);
        var selectedCodes = ref([]);
        var pendingCodes = ref([]); // 임시 저장소
        var codes = ref([]);
        var displayForDyslexic = ref(true);
        var searchQuery = ref('');
        var searchInputRef = ref(null);
        var isComposing = ref(false);
        var queryName = ref('');
        var categoryQueryName = ref('');
        // Methods
        // 검색 결과 계산
        var filteredCodes = computed(function () {
            if (!searchQuery.value.trim())
                return [];
            var query = searchQuery.value.toLowerCase();
            var allCodes = props.options.flatMap(function (opt) { return opt.children || []; });
            // 초성 검색 여부 확인
            var isInitialSearch = isKoreanInitial(query);
            return allCodes.filter(function (code) {
                var _a;
                var label = ((_a = code["lang_".concat(lang.value)]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
                if (isInitialSearch) {
                    // 옵션의 초성을 추출해서 검색어와 비교
                    var initials = extractInitials(label.toLowerCase());
                    return initials.startsWith(query);
                }
                else {
                    // 일반 검색 (부분 일치)
                    return label.includes(query);
                }
            });
        });
        var syncSelectedCodes = function (newInitValue) {
            var allCodes = props.options.flatMap(function (option) { return __spreadArray([
                option
            ], (option.children || []), true); });
            if (Array.isArray(newInitValue)) {
                selectedCodes.value = allCodes.filter(function (option) {
                    return newInitValue.includes(option.code);
                });
            }
            else if (typeof newInitValue === 'string') {
                var selectedOption = allCodes.find(function (option) { return option.code === newInitValue; });
                selectedCodes.value = selectedOption ? [selectedOption] : [];
            }
            else {
                selectedCodes.value = [];
            }
            pendingCodes.value = __spreadArray([], selectedCodes.value, true);
            displayForDyslexic.value = pendingCodes.value.length === 0;
        };
        var updateInitValue = function (newSelectedCodes) {
            var selectedCodes = (newSelectedCodes !== null && newSelectedCodes !== void 0 ? newSelectedCodes : []).map(function (category) { return category.code; });
            emit('update:init-value', selectedCodes);
        };
        var toggleFilterPopup = function () {
            var willOpen = !props.filterVisible;
            emit('filter-toggle-event', props.type, willOpen);
            if (willOpen) {
                if (window.location.hash !== '#filter') {
                    history.pushState({ popupOpen: true }, 'filter', '#filter');
                }
                document.body.style.overflow = 'hidden';
            }
            else {
                if (window.location.hash === '#filter') {
                    var url = window.location.pathname + window.location.search;
                    history.replaceState(null, '', url);
                }
                document.body.style.overflow = '';
            }
        };
        var initPendingCodes = function () {
            pendingCodes.value = [];
            pendingCodes.value = __spreadArray([], selectedCodes.value, true);
        };
        var removeSelectedCode = function (code) {
            pendingCodes.value = pendingCodes.value.filter(function (pending) { return pending.code !== code.code; });
        };
        var resetFilter = function () {
            pendingCodes.value = [];
            displayForDyslexic.value = true;
            selectedCategory.value = null;
            codes.value = [];
        };
        // props.options가 바뀌면 optionsLocal도 동기화
        watch(function () { return props.options; }, function (newVal) {
            if (!selectedCategory.value) {
                codes.value = [];
            }
        });
        var handlePopState = function () {
            if (!props.filterVisible)
                return;
            if (window.location.hash !== '#filter') {
                emit('filter-toggle-event', props.type, false);
                document.body.style.overflow = '';
            }
        };
        onMounted(function () {
            window.addEventListener('popstate', handlePopState);
        });
        onBeforeUnmount(function () {
            window.removeEventListener('popstate', handlePopState);
        });
        var selectCategory = function (category) { return __awaiter(_this, void 0, void 0, function () {
            var hasChildSelected, existsInPending;
            return __generator(this, function (_a) {
                selectedCategory.value = category;
                displayForDyslexic.value = false;
                if (category.children && category.children.length > 0) {
                    codes.value = __spreadArray([], category.children, true);
                }
                else {
                    codes.value = [];
                }
                hasChildSelected = selectedCodes.value.some(function (code) { return code.parent_code === category.code; });
                if (!hasChildSelected) {
                    pendingCodes.value = pendingCodes.value.filter(function (code) { return code.parent_code !== category.code; });
                    existsInPending = pendingCodes.value.some(function (code) { return code.code === category.code; });
                    if (!existsInPending) {
                        pendingCodes.value.push(category);
                    }
                }
                return [2 /*return*/];
            });
        }); };
        // Watchers
        var isFirstPendingSync = true;
        var isInitialSync = true;
        watch(function () { return pendingCodes.value; }, function (newSelected, oldSelected) {
            if (isFirstPendingSync) {
                isFirstPendingSync = false;
                return;
            }
            var normalized = enforceCategoryExclusivity(newSelected, oldSelected);
            var changed = normalized.length !== newSelected.length ||
                normalized.some(function (code, idx) { return code.code !== newSelected[idx].code; });
            if (changed) {
                pendingCodes.value = normalized;
            }
        }, { deep: true });
        watch(function () { return [props.initValue, props.options]; }, function (_a) {
            var initValue = _a[0], options = _a[1];
            if (!options || options.length === 0)
                return;
            console.log('syncSelectedCodes by [initValue, options] watcher:', initValue);
            syncSelectedCodes(initValue);
            // 최초 selectedCodes 변경은 부모 emit 막기
            isInitialSync = true;
        }, { immediate: true, deep: true });
        watch(selectedCodes, function (newSelectedCodes) {
            if (isInitialSync) {
                isInitialSync = false;
                return; // 초기 동기화에서는 emit 안 함
            }
            updateInitValue(newSelectedCodes);
        }, { deep: true });
        watch(function () { return props.filterVisible; }, function (visible) {
            if (!visible) {
                searchQuery.value = '';
            }
        });
        var enforceCategoryExclusivity = function (newSelected, oldSelected) {
            var result = __spreadArray([], newSelected, true);
            var added = newSelected.filter(function (n) { return !oldSelected.some(function (o) { return o.code === n.code; }); });
            if (added.length === 0) {
                return result;
            }
            added.forEach(function (addedCode) {
                if (addedCode.parent_code === props.type) {
                    result = result.filter(function (code) { return code.parent_code !== addedCode.code; });
                }
                else {
                    var categoryCode_1 = addedCode.parent_code;
                    result = result.filter(function (code) { return code.code !== categoryCode_1; });
                }
            });
            return result;
        };
        var previousSearchQuery = "";
        var onKeyup = function (event) {
            var currentQuery = event.target.value;
            // 검색어가 변경되었는지 확인
            if (currentQuery !== previousSearchQuery) {
                previousSearchQuery = currentQuery;
            }
            searchQuery.value = currentQuery;
        };
        // 한글 입력 완료 시 발생
        var handleCompositionEnd = function (event) {
            isComposing.value = false;
            searchQuery.value = event.target.value;
        };
        // 한글 초성 추출 함수
        var extractInitials = function (str) {
            var initialConsonants = [
                'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
            ];
            return str.split('').map(function (char) {
                var code = char.charCodeAt(0) - 44032;
                // 한글이 아닌 경우 그대로 반환
                if (code < 0 || code > 11171) {
                    return char;
                }
                return initialConsonants[Math.floor(code / 588)];
            }).join('');
        };
        var isKoreanInitial = function (str) {
            return /^[ㄱ-ㅎ]+$/.test(str); // 초성만 있는지 확인
        };
        var clearSearch = function () {
            searchQuery.value = '';
        };
        var doesRenderSeperator = function (seq) {
            return (seq + 1) < selectedCodes.value.length;
        };
        // 카테고리 코드 → 카테고리 객체 매핑
        var categoryMap = computed(function () {
            var map = {};
            props.options.forEach(function (cat) {
                map[cat.code] = cat;
            });
            return map;
        });
        // 선택된 코드가 속한 카테고리 라벨 가져오기
        var getCategoryLabel = function (code) {
            // 부모가 type 이라는 건 = 이 코드 자체가 카테고리 (이미 상단 span v-else에서 처리)
            if (code.parent_code === props.type) {
                return code["lang_".concat(lang.value)] || '';
            }
            var parent = categoryMap.value[code.parent_code];
            return parent ? parent["lang_".concat(lang.value)] || '' : '';
        };
        var getQueryNameForCode = function (code) {
            var isCategory = code.parent_code === props.type;
            if (isCategory) {
                var base_1 = "".concat(props.type, "_category_filter");
                return "".concat(base_1, "[]");
            }
            var base = "".concat(props.type, "_filter");
            return "".concat(base, "[]");
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn position-relative d-flex align-items-center", selectedCodes.value.length > 0 ? 'select' : '']),
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (toggleFilterPopup()); })
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            (selectedCodes.value.length == 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(__props.title) + " ", 1),
                                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
                                ], 64))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(selectedCodes.value, function (code, index) {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: 'title_' + code.code
                                    }, [
                                        (code.parent_code != __props.type)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                                _createTextVNode(_toDisplayString(getCategoryLabel(code)) + " > " + _toDisplayString(code['lang_' + lang.value]) + " ", 1),
                                                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
                                            ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                                _createTextVNode(_toDisplayString(code['lang_' + lang.value]) + " > " + _toDisplayString(__props.locales.common_all) + " ", 1),
                                                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
                                            ])),
                                        (doesRenderSeperator(index))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " , "))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 128))
                        ]),
                        _withDirectives(_createElementVNode("span", { class: "position-absolute top-0 start-100 translate-middle badge rounded-circle filter-count-badge" }, _toDisplayString(selectedCodes.value.length), 513), [
                            [_vShow, selectedCodes.value.length > 0]
                        ])
                    ], 2)
                ]),
                _createElementVNode("div", {
                    class: "back_wrap",
                    onClick: _cache[1] || (_cache[1] = function ($event) { return ([toggleFilterPopup(), initPendingCodes()]); })
                }, [
                    _createVNode(_Transition, null, {
                        default: _withCtx(function () { return [
                            (__props.filterVisible)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                                : _createCommentVNode("", true)
                        ]; }),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", {
                    class: "filterUI",
                    id: __props.type + 'Filter'
                }, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", null, _toDisplayString(__props.title), 1),
                            _createElementVNode("span", {
                                class: "close_btn",
                                onClick: _cache[2] || (_cache[2] = function ($event) { return ([toggleFilterPopup(), initPendingCodes()]); })
                            }, _cache[14] || (_cache[14] = [
                                _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                            ]))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                            ref_key: "searchInputRef",
                            ref: searchInputRef,
                            type: "search",
                            onKeyup: onKeyup,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((searchQuery).value = $event); }),
                            onCompositionstart: _cache[4] || (_cache[4] = function ($event) { return (isComposing.value = true); }),
                            onCompositionend: handleCompositionEnd,
                            placeholder: __props.locales.common_search_ph
                        }, null, 40, _hoisted_12), [
                            [_vModelText, searchQuery.value]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((searchQuery).value = $event); })
                        }, null, 512), [
                            [_vModelText, searchQuery.value]
                        ]),
                        (searchQuery.value.trim())
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "bi bi-x-lg",
                                onClick: _withModifiers(clearSearch, ["stop", "prevent"])
                            }))
                            : (_openBlock(), _createElementBlock("i", _hoisted_13))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        (!searchQuery.value.trim())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["list-group-item list-group-item-action", displayForDyslexic.value ? 'select' : '']),
                                            type: "button",
                                            onClick: _cache[6] || (_cache[6] = function ($event) { return (resetFilter()); })
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(__props.locales.common_all), 1)
                                        ], 2),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, function (category) {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: category.code,
                                                class: _normalizeClass(["list-group-item list-group-item-action", { active: selectedCategory.value && selectedCategory.value.code == category.code }]),
                                                type: "button",
                                                onClick: function ($event) { return (selectCategory(category)); }
                                            }, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass({ select: pendingCodes.value.some(function (code) { return code.code.startsWith(category.code); }) })
                                                }, _toDisplayString(category['lang_' + lang.value]), 3),
                                                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1))
                                            ], 10, _hoisted_17));
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _withDirectives(_createElementVNode("div", { class: "filterUI-body-list-item w-100 text-secondary-200 w-100 p-2" }, _toDisplayString(__props.locales.recruit_filter_select), 513), [
                                            [_vShow, !displayForDyslexic.value && !selectedCategory.value]
                                        ]),
                                        _withDirectives(_createElementVNode("div", { class: "filterUI-body-list-item w-100 text-secondary-200 w-100 p-2" }, _toDisplayString(__props.locales.recruit_filter_all), 513), [
                                            [_vShow, displayForDyslexic.value]
                                        ]),
                                        (selectedCategory.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        id: selectedCategory.value.code + '_all',
                                                        type: "checkbox",
                                                        value: selectedCategory.value,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((pendingCodes).value = $event); })
                                                    }, null, 8, _hoisted_22), [
                                                        [_vModelCheckbox, pendingCodes.value]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: selectedCategory.value.code + '_all'
                                                    }, _toDisplayString(__props.locales.common_all), 9, _hoisted_23)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codes.value, function (code) {
                                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                                                class: "filterUI-body-list-item",
                                                key: code.code
                                            }, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        id: code.code,
                                                        type: "checkbox",
                                                        value: code,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((pendingCodes).value = $event); })
                                                    }, null, 8, _hoisted_25), [
                                                        [_vModelCheckbox, pendingCodes.value]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: code.code
                                                    }, _toDisplayString(code['lang_' + lang.value]), 9, _hoisted_26)
                                                ])
                                            ])), [
                                                [_vShow, selectedCategory.value]
                                            ]);
                                        }), 128))
                                    ])
                                ])
                            ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    (filteredCodes.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(__props.locales.common_noresult), 1))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredCodes.value, function (code) {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: code.code,
                                                class: "filterUI-body-list-item"
                                            }, [
                                                _createElementVNode("div", _hoisted_30, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        id: code.code,
                                                        type: "checkbox",
                                                        value: code,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((pendingCodes).value = $event); })
                                                    }, null, 8, _hoisted_31), [
                                                        [_vModelCheckbox, pendingCodes.value]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: code.code
                                                    }, _toDisplayString(code['lang_' + lang.value]), 9, _hoisted_32)
                                                ])
                                            ]));
                                        }), 128))
                                ])
                            ]))
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createTextVNode(_toDisplayString(__props.locales.common_selected) + " " + _toDisplayString(__props.title) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString(pendingCodes.value.length), 1)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingCodes.value, function (code) {
                                return (_openBlock(), _createElementBlock("input", {
                                    key: 'hidden_' + code.code,
                                    type: "hidden",
                                    name: getQueryNameForCode(code),
                                    value: code.code
                                }, null, 8, _hoisted_36));
                            }), 128)),
                            (pendingCodes.value.length == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(__props.locales.common_all), 1))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(pendingCodes.value, function (code) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: 'selected_' + code.code,
                                        class: "d-flex align-items-center"
                                    }, [
                                        (code.parent_code !== __props.type)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("span", _hoisted_38, _toDisplayString(getCategoryLabel(code)) + " > " + _toDisplayString(code['lang_' + lang.value]), 1),
                                                _createElementVNode("button", {
                                                    class: "btn-close btn btn-sm",
                                                    type: "button",
                                                    "aria-label": "Close",
                                                    onClick: _withModifiers(function ($event) { return (removeSelectedCode(code)); }, ["stop", "prevent"])
                                                }, _cache[16] || (_cache[16] = [
                                                    _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                                ]), 8, _hoisted_39)
                                            ], 64))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                                _createTextVNode(_toDisplayString(code['lang_' + lang.value]) + " > " + _toDisplayString(__props.locales.common_all) + " ", 1),
                                                _createElementVNode("button", {
                                                    class: "btn-close btn btn-sm",
                                                    type: "button",
                                                    "aria-label": "Close",
                                                    onClick: _withModifiers(function ($event) { return (removeSelectedCode(code)); }, ["stop", "prevent"])
                                                }, _cache[17] || (_cache[17] = [
                                                    _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                                ]), 8, _hoisted_41)
                                            ]))
                                    ]));
                                }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("button", {
                                    class: "btn btn-sm py-0",
                                    type: "button",
                                    onClick: _cache[10] || (_cache[10] = function ($event) { return (resetFilter()); })
                                }, [
                                    _createTextVNode(_toDisplayString(__props.locales.common_reset), 1),
                                    _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-arrow-counterclockwise" }, null, -1))
                                ])
                            ]),
                            _createElementVNode("button", _hoisted_44, _toDisplayString(__props.locales.common_search), 1)
                        ])
                    ])
                ], 8, _hoisted_8), [
                    [_vShow, __props.filterVisible]
                ])
            ]));
        };
    }
});
